import { IMAGE, PHARMACY, RESTAURANT } from "../utils/constants"
import { Link } from "react-router-dom"
const Home = () => {
  return (
    <div className="flex flex-wrap dark:bg-slate-700 min-h-full ">
    <Link to="/restaurants">
      <div className=" text-black bg-slate-200 p-4 hover:bg-slate-300  shadow-lg m-10 w-[600px] h-[450px] rounded-lg border-dotted border-2 hover:border-black border-white hover:translate-y-[-10px] transform transition-transform duration-300">
        <img src={RESTAURANT} className="w-[600px] h-[300px] rounded" />
        <h1 className="text-blue-950">Food Delivery</h1>
      </div></Link>
     <Link to="/grocery"><div className="  text-black bg-slate-200 p-4 hover:bg-slate-300  shadow-lg m-10 w-[600px] h-[450px] rounded-lg border-dotted border-2 hover:border-black border-white hover:translate-y-[-10px] transform transition-transform duration-300 ">
        <img src={IMAGE} className="w-[600px] h-[300px] rounded" />
        <h1 className="text-blue-950">Mart</h1>
      </div>
</Link> 
      <div className="text-black bg-slate-200 p-4 hover:bg-slate-300  shadow-lg m-10 w-[600px] h-[450px] rounded-lg border-dotted border-2 hover:border-black border-white hover:translate-y-[-10px] transform transition-transform duration-300">
        <img src={PHARMACY} className="w-[600px] h-[300px] rounded" />
        <h1 className="text-blue-950">Pharmacy</h1>
      </div>
    </div>
  )
}
export default Home
